import type { FC } from 'react'
import React, { memo } from 'react'
import PrevButton from 'components/PrevButton'
import SpNumericKeypad from 'components/SpNumericKeypad'
import type { TelInputProps } from '../types'
import { useTelInput } from '../useTelInput'
import styles from './style.module.css'

const SpTelInput: FC<TelInputProps> = ({
  title,
  isOpen,
  isShowPhoneNumberPrefix = false,
  maxLengthLeft = 3,
  maxLengthCenter = 4,
  maxLengthRight = 4,
  initialValue,
  onClickEnter,
  onClickClose,
}) => {
  const {
    left,
    center,
    right,
    value,
    canClickEnter,
    onClickNumber,
    onClickBackSpace,
    onChangeLeft,
    onChangeCenter,
    onChangeRight,
  } = useTelInput({ maxLengthLeft, maxLengthCenter, maxLengthRight, initialValue })

  if (!isOpen) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.modalFrame}>
        <div className={styles.prevButtonArea}>
          <PrevButton onClick={() => onClickClose(value)} />
        </div>
        <div className={styles.title}>
          <span>{title}</span>
        </div>

        <div className={styles.inputArea}>
          <input
            className={styles.input}
            type="text"
            value={left}
            maxLength={maxLengthLeft}
            onChange={onChangeLeft}
          />
          <span className={styles.separator}>-</span>
          <input
            className={styles.input}
            type="text"
            value={center}
            maxLength={maxLengthCenter}
            onChange={onChangeCenter}
          />
          <span className={styles.separator}>-</span>
          <input
            className={styles.input}
            type="text"
            value={right}
            maxLength={maxLengthRight}
            onChange={onChangeRight}
          />
        </div>

        <div className={styles.keypad}>
          {/* Phone number prefix buttons */}
          {isShowPhoneNumberPrefix && (
            <div className={styles.prefixGrid}>
              <button
                className={`${styles.button} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('070')}
                disabled={!!value.length}
              >
                070
              </button>
              <button
                className={`${styles.button} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('080')}
                disabled={!!value.length}
              >
                080
              </button>
              <button
                className={`${styles.button} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('090')}
                disabled={!!value.length}
              >
                090
              </button>
            </div>
          )}

          {/* Number pad（PassCode と共用の SP テンキー） */}
          <SpNumericKeypad
            onClickNumber={onClickNumber}
            onClickBackSpace={onClickBackSpace}
            onClickEnter={() => onClickEnter(value)}
            disabledEnter={!canClickEnter}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(SpTelInput)
